var scope_0 = require('/home/runner/work/simulator.dev/simulator.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/22f7a2e444fda059b4c1046e818d7dd0.js').default;
var scope_1 = require('/home/runner/work/simulator.dev/simulator.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d7ab2a4009d93cfa7cae441824484c8a.js').default;
var scope_2 = require('/home/runner/work/simulator.dev/simulator.dev/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    